import 'bootstrap';
import 'bootstrap4-notify';
import 'bootstrap4-toggle/js/bootstrap4-toggle.min';
import 'select2/dist/js/select2.min';
import 'inputmask';
import '@staaky/fresco/dist/js/fresco.min';
import flatpickr from "flatpickr";
import axios from 'axios';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;
